module.exports = __webpack_public_path__ + "static/media/fdg.fa4f3c8c.png";